module.exports = __webpack_public_path__ + "img/certik.31addf3f.png";